import { FC } from 'react';

import { ProductMetaData } from '../../../models/Product';
import { Article } from '../../../models/Article';
import { useTranslation } from 'react-i18next';
import { mapReleaseFrequency } from './translationMappers/releaseFrequencyMapper';
import styled from 'styled-components';

const StReleaseFrequency = styled.p`
    line-height: 16px;
    margin-bottom: 10px;
`;
interface Props {
    product: ProductMetaData & Article;
}
export const ReleaseFrequency: FC<Props> = prod => {
    const { t } = useTranslation();
    const { product } = prod;

    return (
        <StReleaseFrequency>
            {t(`components.releaseFrequency`, {
                context: product.releaseFrequency ? mapReleaseFrequency(product.releaseFrequency) : undefined,
                quantity: product.releaseQuantity
            })}
        </StReleaseFrequency>
    );
};
